import { useEffect, useState } from 'react'
import './PopupArea.scss'

export enum PopupType {
  Info = 'info',
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
}

export interface IPopup {
  /**
   * Unical identifier.
   */
  id: string

  /**
   * Popup text.
   */
  text: string

  /**
   * Popup type.
   */
  type: PopupType

  /**
   * Popup is visible.
   */
  visible: boolean

  /**
   * Date of popup creation.
   */
  created: number
}

const Popup = (props: IPopup) => {
  const [visible, setVisible] = useState<string>('')

  useEffect(() => {
    const timeout = setTimeout(() => {
      setVisible(props.visible ? 'show' : 'hide')

      // Remove popup
      if (!props.visible) {
        setTimeout(() => {
          setVisible('none')
        }, 300)
      }
    }, 20)

    return () => clearTimeout(timeout)
  }, [props.visible])

  const icon = () => {
    switch (props.type) {
      case PopupType.Info:
        return 'icon-info'
      case PopupType.Success:
        return 'icon-check'
      case PopupType.Error:
        return 'icon-error'
      case PopupType.Warning:
        return 'icon-warning'
    }
  }

  return (
    <div className={['popup', visible, props.type].join(' ')}>
      <i className={icon()}></i> {props.text}
    </div>
  )
}

export default Popup
